const se = {
  "comingSoon": "Boahtá fargga",
  "soonSub": "Ođđa stállobivdu",
  "follow": "Čuovo min ođđasiid",
  "playNow": "Speala Vuotnabálgá dál",
  "prev": "Ovddit bálggis",
  "next": "Boahtte bálggis",
  "of": "/",
  "readMore": "Loga bálgá birra",
  "otherTrails": "Eanet bálgát bohtet",
  "partner": {
    "kicker": "Fitnodagaide ja suohkaniidda",
    "badge": "Fitnodagaide",
    "title": "Šatta Trollfossjakten-guoibmin.",
    "pitch": "Hotealat, kaféat, sávnnat, čuoiganguovddážat ja olles suohkanat sáhttet bidjat iežaset stáluid kártii. Bivdu doalvu bearrašiid ja turisttaid njuolgga du uvssa lusa — olles jagi.",
    "points": [
      "Du báiki merkejuvvon stálukártii",
      "Guossit diŋgot ovdagihtii ja máksit Vippsain",
      "Álggahanhaddi: 50 % vuolideapmi 50 vuosttašii"
    ],
    "cta": "Šatta guoibmin",
    "cta2": "Fitnodagaide",
    "pin": "Du fitnodat dás",
    "stamp": "−50 %"
  },
  "names": {
    "partner": "Šatta guoibmin",
    "fjord": "Vuotnabálggis",
    "stairs": "Midnattsoltrappa",
    "farm": "Ågård-stálut",
    "forest": "Vuovdebálggis",
    "sea": "Mearrastállomátki"
  },
  "slides": {
    "stairs": {
      "kicker": "Spansdalen · Loabát",
      "title": "Midnattsoltrappa: 20 stálu 2117 ceahkis.",
      "pitch": "Muorraráidalas njuolgga bajás várrebálgá Spanstinda / Ruŋgugáisá luhtte — 380 mehtera bajás, ja oaidnu Spansdalena ja Loabátvuona badjel. Guoktelogi stálu vurdet ceahkkiin, geahčadanlávddis ja Henrikkagorži luhtte.",
      "stats": [
        [
          "20",
          "stálut"
        ],
        [
          "2117",
          "ceahkit"
        ],
        [
          "380",
          "mehtera bajás"
        ]
      ],
      "note": "Buoremus gaskaijabeaivvážis geassemánus ja suoidnemánus."
    },
    "farm": {
      "kicker": "Loabát · Romsa",
      "title": "Ågård-stálut: 30 stálu vuomi nuppe bealde.",
      "pitch": "Ođđa geaidnooassi vuomi nuppe bealde, ruoksadis dáluid, suoidnehesjiid, sávzaguohtumiid ja fiervvá meattá. Dállostálut gođđon gahpiriiguin čiehkádit áiddiid ja mielkegievnniid duohken.",
      "stats": [
        [
          "30",
          "stálut"
        ],
        [
          "1",
          "ođđa geaidnu"
        ],
        [
          "4",
          "jahkeáiggit"
        ]
      ],
      "note": "Ođđa geaidnu — ja ođđa stállojoavku."
    },
    "forest": {
      "kicker": "Loabát · Rivttát",
      "title": "Vuovdebálggis: 25 stálu soagi ja beahci gaskkas.",
      "pitch": "Gáržžes bálggis jeahkálas soahke- ja beahcevuovddi čađa, jeakkiid, jogažiid ja uhca šalddiid meattá. Jeagilstálut guobbargahpiriiguin geahččet olggos muorraruumaid ja geđggiid duohken.",
      "stats": [
        [
          "25",
          "stálut"
        ],
        [
          "1",
          "vuovdebálggis"
        ],
        [
          "4",
          "jahkeáiggit"
        ]
      ],
      "note": "Váldde fárrui govvenrusttega — ja veaháš šokoláda."
    },
    "sea": {
      "kicker": "Rivttát · Loabát · Sjøvegan",
      "title": "Mearrastállomátki: dohppe Krakena ja stuorra skilpáttá.",
      "pitch": "Fanasmátki vuonas Rivttágis Loabága bokte Sjøveganii. Čáhcegierragis vurdet mearrastálut ja guokte 45 mehtera guhkkosaš jiehtanasa — Kraken ja boares stuorra skilpáddá mas lea olles suolu čielggis.",
      "stats": [
        [
          "15",
          "mearrastálut"
        ],
        [
          "45 m",
          "guhkes jiehtanasat"
        ],
        [
          "3",
          "hámmanat"
        ]
      ],
      "note": "Sierra fanaspáhkka máksi guossiide."
    }
  }
};

export default se;
